import { io } from 'socket.io-client';
import mitt from 'mitt';
import logdown from 'logdown';
class LetsDialSocketClient {
    apiToken;
    letsDialServerUrl;
    ws;
    // @ts-ignore
    emitter = mitt();
    pendingListeners = [];
    pendingEmits = [];
    streams = [];
    logger = logdown('@letsdial/socket', {
        prefixColor: '#14B8A6',
    });
    options = {};
    listeners = {};
    constructor(letsDialServerUrl, apiToken, socketOptions = {}) {
        this.apiToken = apiToken;
        this.letsDialServerUrl = letsDialServerUrl;
        this.options = socketOptions;
    }
    connect() {
        if (!this.ws || this.ws.connected === false) {
            const options = {
                transports: ['websocket'],
            };
            if (this.apiToken) {
                options.auth = { token: this.apiToken };
                options.query = { token: this.apiToken };
            }
            if (this.letsDialServerUrl) {
                this.ws = io(this.letsDialServerUrl, options);
            }
            else {
                this.ws = io(options);
            }
            this.registerListeners();
        }
    }
    publish(event, params) {
        this.logger.info(`Event ${event}`, { params });
        if (this.options.disableEvents) {
            if (this.listeners[event]) {
                for (const callBack of this.listeners[event]) {
                    callBack(params);
                }
            }
            if (this.listeners['*']) {
                for (const callBack of this.listeners['*']) {
                    callBack(event, params);
                }
            }
        }
        else {
            this.emitter.emit(event, params);
        }
    }
    registerListeners() {
        if (this.ws) {
            this.ws.on('connect', () => {
                this.loadPendingListeners();
                this.sendPendingEmits();
                this.publish('LD:SOCKET:CONNECTED');
                if (this.streams.length > 0) {
                    this.streams.forEach((streamToken) => {
                        const [stream, params] = streamToken.split('|');
                        this.emit(`join:${stream}`, JSON.parse(params));
                    });
                }
            });
            this.ws.on('disconnect', (error) => {
                // if (error === 'io server disconnect') {
                //   // the disconnection was initiated by the server, you need to reconnect manually
                //   this.ws.connect()
                // }
                this.publish('LD:SOCKET:DISCONNECT', error);
                // else the socket will automatically try to reconnect
            });
            this.ws.on('connect_error', (error) => {
                this.publish('LD:SOCKET:CONNECTION:ERROR', error);
            });
            this.ws.io.on('error', (error) => {
                this.publish('LD:SOCKET:ERROR', error);
            });
            this.ws.io.on('reconnect', (attemptNumber) => {
                this.publish('LD:SOCKET:RECONNECTED', attemptNumber);
            });
            this.ws.io.on('reconnect_attempt', (attemptNumber) => {
                this.publish('LD:SOCKET:RECONNECTING', attemptNumber);
            });
            this.ws.io.on('reconnect_error', (error) => {
                this.publish('LD:SOCKET:RECONNECT:ERROR', error);
            });
            this.ws.io.on('reconnect_failed', () => {
                this.publish('LD:SOCKET:RECONNECT:FAILED');
            });
            this.ws.onAny((event, args) => {
                this.publish(event, args);
            });
        }
    }
    close() {
        this.logger.info('Closing Websocket');
        this.ws?.close();
        this.clearListeners();
    }
    loadPendingListeners() {
        if (!this.options.disableEvents) {
            this.pendingListeners.forEach(({ event, callback, vm }) => {
                console.log('loadPending', event, callback);
                if (vm) {
                    this.emitter.on(event, callback.bind(vm));
                }
                else {
                    this.emitter.on(event, callback);
                }
            });
        }
        this.pendingListeners = [];
    }
    sendPendingEmits() {
        this.pendingEmits.forEach(({ event, args }) => {
            console.log('pendingEmits', event);
            this.ws?.emit(event, ...args);
        });
        this.pendingEmits = [];
    }
    joinStream(stream, params) {
        this.streams.push(`${stream}|${JSON.stringify(params)}`);
        this.emit(`join:${stream}`, params);
    }
    leaveStream(stream, params) {
        this.emit(`leave:${stream}`, params);
        this.streams.filter((value, index, arr) => {
            if (value === `${stream}|${JSON.stringify(params)}`) {
                arr.splice(index, 1);
                return true;
            }
            return false;
        });
    }
    on(event, callback) {
        if (this.options.disableEvents) {
            if (!this.listeners[event]) {
                this.listeners[event] = [];
            }
            else {
                this.listeners[event].push(callback);
            }
        }
        else {
            if (!this.ws) {
                this.pendingListeners.push({ event, callback });
            }
            this.emitter.on(event, callback);
        }
    }
    off(event, callback) {
        if (this.options.disableEvents) {
            if (this.listeners[event]) {
                this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
            }
        }
        else {
            this.emitter.off(event, callback);
        }
    }
    clearListeners() {
        if (!this.options.disableEvents) {
            this.emitter.all.clear();
        }
        this.listeners = {};
    }
    emit(event, ...args) {
        if (!this.ws) {
            this.pendingEmits.push({ event, args });
        }
        else {
            this.ws.emit(event, ...args);
        }
    }
}
export default LetsDialSocketClient;
